export default __webpack_public_path__ + "static/media/64t.9f32cf2e.jpg";